<nav>
    <a mat-button class="docs-button" routerLink="/" aria-label="Angular Material">
        <img class="logo" src="../../../assets/images/ct_logo_white.png" alt="ComplyTRI">
    </a>
    <div class="titleBar">{{ title }}</div>
    <span class="nav-actions">
        @if (showHome) {
        <button class="icon-button" [routerLink]="['/portal/facility']" mat-icon-button color="white"
            aria-label="Home" matTooltip="Go to Facility">
            <mat-icon>home</mat-icon>
        </button>
        } @else {
            @if (showAdmin) {
                <button class="icon-button" [routerLink]="['/admin']" mat-icon-button color="white" aria-label="Admin" matTooltip="Go to Admin">
                    <mat-icon>settings_application</mat-icon>
                </button>
            }
        }
        <button mat-icon-button color="white" class="icon-button" (click)="onMessagesClicked()" 
                [matBadge]="unreadMessageCount" [matBadgeHidden]="unreadMessageCount === 0" 
                matBadgeColor="warn" matBadgeSize="small" matTooltip="Messages">
            <mat-icon>message</mat-icon>
        </button>
        <button mat-icon-button color="white" class="icon-button" [matMenuTriggerFor]="userMenu">
            <mat-icon>account_circle_outline</mat-icon>
        </button>
        <mat-menu #userMenu="matMenu">
            <button mat-menu-item (click)="onNotificationsClicked()">
                <mat-icon>notifications</mat-icon>
                Notifications
            </button>            

            <button mat-menu-item (click)="onAboutClicked()">
                <mat-icon>info</mat-icon>
                About
            </button>            
            <button mat-menu-item (click)="onLogoutClicked()">
                <mat-icon>exit_to_app</mat-icon>
                Logout
            </button>
        </mat-menu>
    </span>
</nav>